import {useI18n} from 'i18n/I18nContext'
import React from 'react'
import {useEditor} from 'TemplateEditor/EditorProvider'
import {useTemplate} from 'TemplateEditor/TemplateProvider'
import {getByNestedKeys} from 'utils/lib/json'
import {ListBlocks} from 'TemplateEditor/Layout/Blocks'
import SmartphoneIcon from '@mui/icons-material/Smartphone'
import LaptopMacIcon from '@mui/icons-material/LaptopMac'
import {TEMPLATE_EDITOR_ACTIVE_FORM_ID} from 'TemplateEditor/templateEditorFormId'
import {EditorConfigTopBar} from 'TemplateEditor/EditorConfigTopBar'
import {templateEditorTitleKeyForBlockType} from 'TemplateEditor/editorPanelTitles'

export function Config() {
  const {t} = useI18n()
  const {setEditElement, editElement, mobileMode, setMobileMode} = useEditor()
  const {template} = useTemplate()

  const handleToggleMobileMode = () => setMobileMode(!mobileMode)

  const blockForTitle = editElement
    ? getByNestedKeys(template, editElement)
    : null
  const blockTitleKey =
    blockForTitle &&
    typeof blockForTitle === 'object' &&
    'type' in blockForTitle
      ? templateEditorTitleKeyForBlockType(
          String((blockForTitle as {type: string}).type),
        )
      : 'templateEditor.sidebarElementsTab'

  return (
    <>
      <div className={'offcanvas__editor info-open'}>
        <div className="offcanvas__wrapper">
          <div className="offcanvas__content template-editor-config-split">
            <div className="template-editor-config-sticky">
              <EditorConfigTopBar
                itemLabel={t(blockTitleKey)}
                backLabel={t('templateEditor.backToLayout')}
                onBack={() => setEditElement(null)}
              />

              <div className={`bd-theme-toggle mb-20 d-block`}>
                <label
                  className="bd-theme-toggle-main"
                  style={{width: '100%'}}
                  htmlFor="template-editor-config-mobile-toggle"
                >
                  <span
                    className={`bd-theme-toggle-dark ${!mobileMode ? 'active' : ''}`}
                  >
                    <LaptopMacIcon style={{fontSize: 18}} />{' '}
                    {t('templateEditor.sidebarDesktop')}
                  </span>
                  <input
                    type="checkbox"
                    id="template-editor-config-mobile-toggle"
                    checked={!mobileMode}
                    onChange={handleToggleMobileMode}
                  />
                  <i className="bd-theme-toggle-slide"></i>
                  <span
                    className={`bd-theme-toggle-light ${mobileMode ? 'active' : ''}`}
                  >
                    <SmartphoneIcon style={{fontSize: 18}} />{' '}
                    {t('templateEditor.sidebarMobile')}
                  </span>
                </label>
              </div>
            </div>

            <div className="template-editor-config-scroll">
              <Configurator key={editElement ?? 'config'} />
            </div>

            <div className="template-editor-config-footer">
              <button
                className="input__btn w-100 template-editor-save-submit"
                type="submit"
                form={TEMPLATE_EDITOR_ACTIVE_FORM_ID}
              >
                {t('templateEditor.save')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

function Configurator() {
  const {editElement, mobileMode} = useEditor()
  const {template} = useTemplate()

  const block = getByNestedKeys(template, editElement)

  if (!block) return null

  for (const ListBlock of ListBlocks) {
    if (block.type === ListBlock.typeId) {
      return mobileMode ? ListBlock.mobileConfig() : ListBlock.config()
    }
  }

  return null
}
